
import React, { useEffect, useRef } from "react";
import { ReactNode } from "react";
import "../Controls/searchfilterdropdown.scss";
export default function InputWithDropdown({ clsName,placeHolder, onChange,defaultValue,onClear,options,onSelect,loading,onFinalize}:{clsName:string,onFinalize:(text:string)=>void,loading?:boolean,onSelect:(id:string,data:any)=>void,defaultValue:string,placeHolder:string,onClear:()=>void, onChange:(val:string)=>void, options:{content:ReactNode,id:string,data?:any,isHeading?:boolean }[]}) {


    const [showOptions, setShowOptions] = React.useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const [selectedIndex, setSelectedIndex] = React.useState(-1);

    useEffect(() => {
        if(selectedIndex>=options.length){
            setSelectedIndex(options.length-1);
        }

    },[options])


    useEffect(() => {

        if(containerRef.current){
            let optionDoms = containerRef.current.querySelectorAll(".filter-item");
            if (selectedIndex >= 0 && selectedIndex < optionDoms.length) {
                optionDoms[selectedIndex].scrollIntoView({  block: "nearest" });
            }
        }

    }, [selectedIndex]);


    const handleClickOutside = (event: MouseEvent) => {

        if (showOptions&& containerRef.current && !containerRef.current.contains(event.target as Node)) {
            setShowOptions(false);
            onFinalize(defaultValue);
        }


    };

    const handleKey = (e:any)=>{
        if (e.key === "Enter"||e.key === "Tab"||e.key === "Escape") {
            setShowOptions(false);

            if(e.key==="Enter"&& selectedIndex>=0&&selectedIndex<options.length){
                let optn = options[selectedIndex];
                if (optn.isHeading) return;
                onChange(optn.id);
                onSelect(optn.id, optn.data);
                onFinalize(optn.id);
            }
            else{
                onFinalize(defaultValue);
            }

        }
        else if(e.key === "ArrowDown") {
            e.preventDefault();
            if(selectedIndex<options.length-1){
                setSelectedIndex(selectedIndex+1);
            }
        }
        else if(e.key === "ArrowUp") {
            e.preventDefault();
            if(selectedIndex>0){
                setSelectedIndex(selectedIndex-1);
            }
        }
    }

    useEffect(() => {

        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        }
    }, [showOptions,defaultValue]);



    return <div ref={containerRef}
    onFocus={() => setShowOptions(true)}
    className={"relative w-full  search-input  "+clsName + (defaultValue.length <= 0 ? " empty" : "")} style={{ fontSize: "16px" }}>

        <SearchIcon />

        <input  onKeyDown={handleKey} onFocus={()=>{
            if(selectedIndex>=0){
                setSelectedIndex(-1);
            }
        }} value={defaultValue} defaultValue={defaultValue} maxLength={100} className="w-full" type="text" style={{ padding: "10px 28px 10px 28px", borderRadius: "4px", border: "1px solid #c7c7c7", outline: "none" }} placeholder={placeHolder}
            onInput={(e) =>{ onChange((e.target as HTMLInputElement).value); setShowOptions(true); setSelectedIndex(-1); }}
        />

        {defaultValue.length > 0 &&
            <div style={{ left: "inherit", position: "absolute", right: "8px", top: "10px", zIndex: 5 }} onClick={() =>{ onClear();
                onChange("");
                onFinalize("");


            }}>
                <ClearIcon />
            </div>
        }
        {showOptions&&loading&&
            <div className="search-filter-dropdown">
                <div className="filter-item loading">
                    Loading...
                </div>
            </div>
        }
        {!loading&& showOptions&&defaultValue.length>2&& <div className="search-filter-dropdown">
                {options.length>0&& options.map((d, i) => {

                    return <div role="button" key={i} className={"filter-item " + (d.isHeading ? "filter-heading" : "")+(selectedIndex==i?" selected":"")}
                    onClick={() => {
                        if (d.isHeading) return;
                        onSelect(d.id, d.data);
                        onFinalize(d.id);
                        setShowOptions(false);

                    }}
                    >
                     {d.content}
                    </div>
                })
                }
                {options.length<=0&&<div className="filter-item no-results">No results found</div>}


        </div>

        }

    </div>



}

function SearchIcon(){
   return <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#333" style={{ position: "absolute", left: "8px", top: "16px", pointerEvents: "none" }}><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>
}

function ClearIcon(){

return             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
</svg>
}